import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogActions,
  DialogContent,
} from 'components/common/Dialog';
import Button from 'components/common/Button';

const styles = () => ({
  message: {
    padding: '60px 85px',
  },
  subheading: {
    marginBottom: 17,
  },
});

const PatientInformationEditConfirmationDialog = ({
  open, onClose, onSubmit, actions, history, classes, variant, ...otherProps
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogContent>
      <div className={classes.message}>
        <Typography
          className={classes.subheading}
          variant="subheading"
        >
          Are you sure that you want to {variant === 'create' ? 'create new' : 'update'} chart for patient
          {` ${otherProps['Last Name']}`}
          {`, ${otherProps['First Name']}`}
          {otherProps['Middle Name'] && ` ${otherProps['Middle Name']}`}
          ?
        </Typography>
        <Typography color="secondary">
          Сaution: similar patient may be already created
        </Typography>
      </div>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={onSubmit}
        variant="raised"
        color="primary"
      >
        CONFIRM
      </Button>
    </DialogActions>
  </Dialog>
);

PatientInformationEditConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  'First Name': PropTypes.string,
  'Middle Name': PropTypes.string,
  'Last Name': PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  classes: PropTypes.shape({
    message: PropTypes.string.isRequired,
    subheading: PropTypes.string.isRequired,
  }).isRequired,
};

PatientInformationEditConfirmationDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmit: () => {},
  'First Name': '',
  'Middle Name': '',
  'Last Name': '',
};

export default withStyles(styles)(PatientInformationEditConfirmationDialog);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/PatientInformation/PatientInformationEditConfirmationDialog.js